import { AnyCommonSynchronizationEnvironmentTypesConstraint } from '../../types/CommonSynchronizationEnvironmentTypes';
import { EntityByEntityName } from '../../types/EntityByEntityName';
import { EntityInfo } from '../EntityInfo/EntityInfo';
import { FieldInfoHandler } from '../FieldInfoHandler/FieldInfoHandler';
export class FieldInfoHandlerCache {
  private static handlerCache: WeakMap<EntityInfo<any, any, any>, FieldInfoHandler<any, any>> = new WeakMap();
  private static defaultValueHandlerCache: WeakMap<EntityInfo<any, any, any>, FieldInfoHandler<any, any>> = new WeakMap();
  private constructor() {}
  public static getDefaultValueHandlerForEntityInfo<TCommonSynchronizationEnvironmentTypes extends AnyCommonSynchronizationEnvironmentTypesConstraint, TEntityName extends TCommonSynchronizationEnvironmentTypes['EntityName'], TEntityByEntityName extends EntityByEntityName<TCommonSynchronizationEnvironmentTypes>>(entityInfo: EntityInfo<TCommonSynchronizationEnvironmentTypes, TEntityName, TEntityByEntityName[TEntityName]>): FieldInfoHandler<TCommonSynchronizationEnvironmentTypes, TEntityByEntityName[TEntityName]> {
    let fieldInfoHandler = this.defaultValueHandlerCache.get(entityInfo);
    if (!fieldInfoHandler) {
      fieldInfoHandler = this.getForEntityInfo(entityInfo).filterInfos(({
        fieldInfo
      }) => {
        return fieldInfo.defaultValue !== undefined;
      });
      this.defaultValueHandlerCache.set(entityInfo, fieldInfoHandler);
    }
    return fieldInfoHandler;
  }
  public static getForEntityInfo<TCommonSynchronizationEnvironmentTypes extends AnyCommonSynchronizationEnvironmentTypesConstraint, TEntityName extends TCommonSynchronizationEnvironmentTypes['EntityName'], TEntityByEntityName extends EntityByEntityName<TCommonSynchronizationEnvironmentTypes>>(entityInfo: EntityInfo<TCommonSynchronizationEnvironmentTypes, TEntityName, TEntityByEntityName[TEntityName]>): FieldInfoHandler<TCommonSynchronizationEnvironmentTypes, TEntityByEntityName[TEntityName]> {
    let fieldInfoHandler = this.handlerCache.get(entityInfo);
    if (!fieldInfoHandler) {
      fieldInfoHandler = FieldInfoHandler.createForEntityInfo(entityInfo);
      this.handlerCache.set(entityInfo, fieldInfoHandler);
    }
    return fieldInfoHandler;
  }
}